import React from "react";
import { Shield, TrendingUp, Scale, Globe, Lock, Award } from "lucide-react";

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Shield />,
      title: "Exclusive Legal Rights",
      description: "Federal trademark registration grants you exclusive rights to use your mark nationwide. No one else can legally use a confusingly similar mark in your industry, giving you complete control over your brand identity and preventing copycats from capitalizing on your success.",
    },
    {
      icon: <TrendingUp />,
      title: "Increased Brand Value",
      description: "A registered trademark significantly increases your company's valuation and market credibility. It's a tangible asset that can be licensed, franchised, or sold, making your business more attractive to investors, partners, and potential buyers.",
    },
    {
      icon: <Scale />,
      title: "Legal Enforcement Power",
      description: "Registration gives you the legal standing to sue infringers in federal court and recover damages, profits, and attorney fees. You can also use your registration to stop counterfeit goods at the border and take down infringing online content quickly.",
    },
    {
      icon: <Globe />,
      title: "Nationwide Protection",
      description: "Unlike common law rights that only protect you in areas where you operate, federal registration provides protection across all 50 states. This is crucial for businesses planning to expand or operate online with customers nationwide.",
    },
    {
      icon: <Lock />,
      title: "Prevents Future Conflicts",
      description: "Your registered trademark creates a public record that deters others from adopting similar marks. The USPTO will reject applications that conflict with yours, preventing costly disputes before they start and protecting your brand from dilution.",
    },
    {
      icon: <Award />,
      title: "Professional Credibility",
      description: "The ® symbol signals to customers, competitors, and partners that you're serious about your brand. It builds trust and legitimacy, showing that you've invested in protecting your business and are committed to quality and professionalism.",
    },
  ];

  return (
    <section id="benefits" className="benefits-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Benefits of Trademark Registration</h2>
          <p className="section-subtitle">
            Why Every Business Needs Federal Trademark Protection
          </p>
        </div>

        <div className="benefits-intro-card">
          <h3 className="benefits-heading">Protect Your Most Valuable Asset</h3>
          <p className="benefits-text">
            Your brand is the face of your business and one of your most valuable assets. Federal trademark registration with the USPTO provides powerful legal protections that go far beyond what common law or state registration can offer. Here's what you gain when you register your trademark:
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon-wrapper">
                <div className="benefit-icon">{benefit.icon}</div>
              </div>
              <h4 className="benefit-title">{benefit.title}</h4>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
